var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "fade" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showModal,
            expression: "showModal",
          },
        ],
        staticClass: "modal-mask",
        attrs: { tabindex: "0" },
        on: {
          keydown: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
            )
              return null
            return _vm.modal.dismiss()
          },
        },
      },
      [
        _c("transition", { attrs: { name: "dmodal" } }, [
          _vm.showModal
            ? _c(
                "div",
                {
                  ref: "modalRef",
                  staticClass: "modal modalMobileFull",
                  class: _vm.classes,
                  staticStyle: { display: "flex" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "modal-dialog modal-content" },
                    [
                      _c(
                        _vm.component,
                        _vm._g(
                          _vm._b(
                            { tag: "component" },
                            "component",
                            _vm.props,
                            false
                          ),
                          _vm.listeners
                        )
                      ),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }